<template>
  <div class="comment-area-list " :class="'level-' + oReply.nReplyLevel">
    <!-- 댓글 작성자 이미지 -->
    <div class="user-photo">
      <img v-lazy.container="oUser.strProfileImg" width="100%"/>
    </div>
    <div class="user-info">
      <!-- 댓글 작성자 -->
      <p class="name" :class="'bUserBlock'+oReply.bUserBlock">
        {{ oUser.strNickName }}
      </p>
      <!-- 댓글 등록일 -->
      <p class="date">
        {{ oReply.strRegDate }}
      </p>
      <div class="msg-block">
        <!-- 댓글 지식 채택 -->
        <span class="knowledgeIn" v-if="oReply.arrContent.isKnowledgeInSelected === 'Y'">채택</span>
        <img :src="emoticon_path" v-if="oReply.arrContent.emoticon.num > 0 " class="emoticon-img"/>
        <img :src="attach_path" v-if="oReply.arrContent.attach.num > 0 " class="attach-file" @click="viewExpand"/>
        <span class="replyContent" :class="'bUserBlock'+oReply.bUserBlock"
              v-html="oReply.arrContent.strContent"></span>
      </div>
      <button class="btn-replay" @click="replyComment">
        댓글
      </button>
    </div>
    <div class="option" v-if="oUser.strUserId === $store.state.userId">
      <img src="@/assets/svg/expand_btn.svg" class="extend-btn" @click.stop="replyToggleParentClass($event,'on')">
      <div class="option_popup">
        <ul>
          <li v-if="oReply.bMyRegistrationReply ">
            <a @click="modifyComment ">
              수정
            </a>
          </li>
          <li v-if="oReply.bMyRegistrationReply ">
            <a @click="setBoardReplyDel(oReply.nReplyNum)">
              삭제
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 추천 -->
    <div class="like-area"
         v-if="oReply.strEventBtn === 'recommand'">
      <button class="btn-like"
              :class="'bUserBlock'+oReply.bUserBlock"
              @click="setReplyRecommend( oReply.nReplyNum)">
        {{ oReply.nRecommendCnt | comma }}
      </button>
    </div>
    <!-- 삭제된게시글 -->
    <div  v-else-if="oReply.strEventBtn === 'deleted'"></div>
    <!-- 채택 -->
    <div class="like-area" v-else>
      <button class="btn-replay no-mrg-top"
              @click="setKnowledge(oReply.nReplyNum)">
        {{ (oReply.strEventBtn === 'selected') ? '채택하기' : '채택취소' }}
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: "Comment",
  props: {
    oReply: Object,
    oUser: Object,
    boardId: Number,
    boardSeq: Number,
    cidx: Number,
  },
  data (){
    return {
    }
  },
  created() {
  },
  computed : {
    emoticon_path () {
      if( this.oReply.arrContent.emoticon.num > 0 ) {
        return process.env.VUE_APP_CDN + this.oReply.arrContent.emoticon.strFilePath
      }
      return ''
    },
    attach_path () {
      if( this.oReply.arrContent.attach.num ){
        return process.env.VUE_APP_MOBIGO_URL + this.oReply.arrContent.attach.strFilePath;
      }
      return ''
    }
  },
  methods: {
    // 댓글 추천 (OK)
    setReplyRecommend(replySeq) {
      // 더블클릭 방지 체크
      if (this.isSending) {
        return false;
      }
      this.isSending = true;
      this.ajaxGetAuth('/api/v1/reply/recommend/' + this.boardId + '/' + this.boardSeq + '/' + replySeq, {}, this.setReplyRecommendResult);
    },
    // 댓글 추천 결과 (OK)
    setReplyRecommendResult(response) {
      this.isSending = false;
      if (response.result.code == 4001) {
        this.oReply.nRecommendCnt++
      }
      this.toastMsg(response.result.resultNoti.message, 1500, 'middle');
    },
    // 댓글 삭제
    setBoardReplyDel(nReplyNum) {
      // 더블클릭 방지 체크
      if (this.isSending) {
        return false;
      }
      this.isSending = true;
      let boardActiveCode = this.boardId;
      let boardSeq = this.boardSeq;
      let replyNum = nReplyNum;
      let formData = new FormData();
      formData.append('num', this.cidx);
      const url = '/api/v1/reply/delete/' + boardActiveCode + '/' + boardSeq + '/' + replyNum
      this.ajaxPostAuth(url, formData, this.setBoardReplyDelResult);
    },
    // 댓글 삭제 결과
    setBoardReplyDelResult(response) {
      this.isSending = false;
      this.toastMsg(response.result.resultNoti.message, 1500, 'middle');
      if (response.result.code == 5035) {
        // TODO : CommentForm 에 삭제 요청
        this.$emit("deleteComment", this.cidx)
      }
    },
    // 대댓글.
    replyComment() {
      let imageType, imagePath
      if( this.oReply.arrContent.emoticon.num ){
        imageType = "emoticon"
        imagePath = this.emoticon_path
      } else if (this.oReply.arrContent.attach.num ) {
        imageType = "attach"
        imagePath = this.attach_path
      }

      this.$emit("sendToRegForm", {
        reply: {
          comment_num : this.oReply.nReplyNum,
          username : this.oUser.strNickName,
          conetent : this.oReply.arrContent.strContent,
          imageType : imageType,
          imagePath : imagePath
        }
      });
    },
    // 수정
    modifyComment () {
      this.$emit("sendToRegForm", {
        origin: {
          comment_num : this.oReply.nReplyNum,
          conetent: this.oReply.arrContent.strContent,
          emoticon : this.oReply.arrContent.emoticon,
          attach : this.oReply.arrContent.attach
        }
      });
    },

    setKnowledge(nReplyNum) {
      // 더블클릭 방지 체크
      if (this.isSending) {
        return false;
      }

      this.isSending = true;

      let formData = new FormData();
      let boardActiveCode = this.boardId;
      let boardSeq = this.boardSeq;
      this.ajaxPostAuth('/api/v1/reply/knowledge/' + boardActiveCode + '/' + boardSeq + '/' + nReplyNum, formData, this.setKnowledgeResult);
    },
    // 지식인 채택/취소 결과
    setKnowledgeResult(response) {
      this.isSending = false;

      this.toastMsg(response.result.resultNoti.message, 1500, 'middle');
    },

    // 댓글 등록, 수정
    setReplyRegister(nParentReplyNum, strReplyContent, mode = 'register') {

      // 더블클릭 방지 체크
      if (this.isSending) {
        return false;
      }
      this.isSending = true;
      let formData = new FormData();
      formData.append('strReplyContent', strReplyContent);
      const url = '/api/v1/reply/' + mode + '/' + this.boardId + '/' + this.boardSeq + '/' + nParentReplyNum
      this.ajaxPostAuth(url, formData, this.setReplyRegisterResult);
    },

    // 댓글 등록, 수정 결과
    setReplyRegisterResult(response) {
      this.isSending = false;
      this.strReplyContent = "";
      if (response.result.code == 0) {
        this.page = 1;
        this.replyTotalCnt = 0;
        this.replyInfo = [];
        this.replyMore = true;
        this.getReplyList();
        this.toastMsg(response.result.resultNoti.message, 1500, 'middle');
        window.location.href = "#focus-comment-area";
      } else {
        this.toastMsg(response.result.resultNoti.message, 1500);
      }
    },

    // 댓글 옵션 선택
    replyToggleParentClass(e, className) {
      let element = e.currentTarget.parentElement;
      const selfDisplay = element.classList.contains(className);
      // 내가 선택한 댓글pop 상태 저장 (자기자신을 다시 클릭했을 경우 안보이도록 처리)

      this.removeUserPopup();
      this.$nextTick(function () {
        if (!selfDisplay) {
          element.classList.add(className);
        }
      });
    },
    viewExpand() {
      const width = window.innerWidth
      const height = window.innerHeight
      const prevBackKeyEvent = window.callbackBackKey
      const panel = this.$showPanel({
        component: () => import('@/views/slide/ImageViewer'),
        props : {imagePath : this.attach_path},
        openOn: 'bottom',
        width: width,
        height: height
      })
      panel.promise.then(() => {
        window.callbackBackKey = prevBackKeyEvent ;
      });
    }
  }
}
</script>

<style scoped>
.msg-block{
  width: calc(100% - 40px);
}
.emoticon-img{
  display: block;
  width: 20%;
  max-width: 100px;
}
.attach-file{
  display: block;
  width: 20%;
  max-width: 100%;

}
.level-0 {
  margin-left: 0;
}

.level-1 {
  margin-left: 15px;
}

.level-2 {
  margin-left: 30px;
}

.level-3 {
  margin-left: 45px;
}

.level-4 {
  margin-left: 60px;
}

.level-5 {
  margin-left: 75px;
}
.extend-btn{
  width: 26px;
  height: 26px;
  cursor: pointer;
}

.comment-area ul li:last-child .comment-area-list {
  border-bottom: none;
  padding-bottom: 0;
}

.comment-area-list {
  position: relative;
  padding: 10px 0;
  border-bottom: 1px solid #dcdfe5;
}

.comment-area-list .user-photo {
  width: 42px;
  position: absolute;
  left: 0;
}

.comment-area-list .user-photo img {
  border-radius: 7px;
}

.comment-area-list .user-info {
  margin-left: 50px;
}

.comment-area-list .user-info .name {
  font-size: 16px;
  font-weight: 500;
}

.comment-area-list .date {
  color: #7a7c7f;
  letter-spacing: 0;
}

.comment-area-list .msg {
  font-size: 14px;
}

.comment-area-list .msg.on .replyContent {
  display: none
}

.comment-area-list .btn-replay {
  display: inline-block;
  background: transparent;
  color: #898a8e;
  letter-spacing: -2px;
  margin-top: 10px;
  outline: unset;
  min-width: 30px;
  text-align: left;
}

.comment-area-list .btn-replay:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.comment-area-list .like-area {
  position: absolute;
  top: 10px;
  right: 0
}

.comment-area-list .like-area .btn-like {
  background-image: url("../../assets/images/icon-like-big.png");
  color: #0086ff;
  background-color: transparent;
  font-weight: 500;
  background-repeat: no-repeat;
  background-size: 15px 14px;
  background-position: center left;
  height: 20px;
  text-align: right;
  padding-left: 20px;
  outline: unset
}

.comment-area-list .like-area .btn-like:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.comment-area ul li .replay-area li {
  border-bottom: none;
  padding: 0px 0 0;
  margin-left: 15px;
}

.comment-area .write-area {
  padding-left: 0;
  margin: 5px 0 0 0;
}

.comment-area .btn-replay + .write-area {
  display: none
}

.comment-area .btn-replay.on + .write-area {
  display: block
}

.comment-area .write-area .write-button-area {
}

.comment-area .write-area .write-button-area button {
  position: relative
}

.comment-area-list > .user-info > .msg > .write-area {
  display: none
}

.comment-area-list > .user-info > .msg > p {
  display: inline-block
}

.comment-area-list > .user-info > .msg > .replyNickName {
  margin-right: 5px
}

.comment-area-list > .user-info > .msg.on > p {
  display: none
}

.comment-area-list > .user-info > .msg.on > .write-area {
  display: block;
  padding-right: 10px
}

.replay-area .comment-area-list {
  padding: 0
}

.replay-area .comment-area-list .like-area {
  top: 0
}

.option {
  position: absolute;
  right: -10px;
  top: 35px;
  font-weight: 500;
  font-size: 11px;
  color: #999;
}

.option .btn_option {
  width: 26px;
  height: 22px;
  background: url('../../assets/images/btn_option_01_on.jpg') center 0 no-repeat;
  background-size: 16px 22px;
  border: 0;
  font-size: 0;
  line-height: 0;
  overflow: hidden;
  text-indent: -999px;
  vertical-align: middle;
  outline: unset
}

.option .btn_option:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.option .option_popup {
  display: none;
  position: absolute;
  right: 0;
  top: 22px;
  background-color: #0086ff;
  border-radius: 5px 0 5px 5px;
  z-index: 1;
}

.option .option_popup li a {
  display: block;
  line-height: 35px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  width: 90px;
}

.option.on .option_popup {
  display: block;
}

</style>